module.exports = __webpack_public_path__ + "img/CS_3_Section_5_character-01.4a0d9791.png";